import React from 'react';

const SVG = ({
  id = 'insights',
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 25 25',
  title = 'Insights',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-accounts-1 { fill: none; }
          .${id}.svg-fill-insights { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1" transform="translate(-59.291 -10)">
        <rect className="svg-insights-1" width="18.888" height="21" />
        <path
          className={`${id} svg-fill-insights`}
          d="M76.451 21.933l-1.189.984c1.11 1.138 1.524 2 1.365 2.289-.229.422-2.109.474-5.1-.6A31.142 31.142 0 0 0 71.8 20.5a31.6 31.6 0 0 0-.2-3.506c2.8-1.127 4.595-1.168 4.839-.767.171.285-.2 1.164-1.247 2.355l1.239.922c1.327-1.528 1.965-3 1.309-4.07-.881-1.447-3.468-1.134-6.365 0C70.834 12.37 69.752 10 68.059 10c-1.2 0-2.092 1.2-2.7 2.979l1.507.381c.433-1.2.9-1.839 1.2-1.839.467 0 1.369 1.554 1.864 4.53a31.714 31.714 0 0 0-3.095 1.659 30.508 30.508 0 0 0-3.352 2.36c-2.038-1.689-2.842-3.052-2.632-3.435.141-.261.928-.366 2.188-.176l.381-1.507c-1.858-.313-3.337-.1-3.909.956-.763 1.406.589 3.341 2.79 5.186-2.079 1.939-3.311 3.922-2.482 5.278.626 1.027 2.113 1.164 3.954.757l-.459-1.485c-1.247.253-2.038.186-2.192-.066-.225-.371.491-1.755 2.413-3.528a30.977 30.977 0 0 0 3.42 2.154c.93.5 1.9.969 2.861 1.372-.51 2.567-1.318 3.9-1.753 3.9-.332 0-.889-.774-1.363-2.293l-1.429.579C65.882 29.691 66.8 31 68.059 31c1.586 0 2.636-2.077 3.21-4.858 3.088 1.084 5.857 1.333 6.695-.212.602-1.104-.111-2.538-1.513-3.997zm-8.772.934a28.211 28.211 0 0 1-2.947-1.837 28.37 28.37 0 0 1 2.891-2.017c.9-.546 1.721-.977 2.505-1.357a28.442 28.442 0 0 1-.069 6.361c-.748-.325-1.531-.689-2.379-1.15z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
